import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import {
  FetchAlertEmailLogsActions,
} from 'store/ducks/alertEmailLogs/fetchAlertEmailLogs';
import * as S from './styles';
import { Scaffold } from 'layouts';

export const EmailLogShow: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data, loading } = useSelector((state: any) => state.fetchAlertEmailLogs);

  useEffect(() => {
    if (id) {
      dispatch(FetchAlertEmailLogsActions.request(id));
    }
  }, [dispatch, id]);

  const receivers = data?.receivers?.replaceAll(';', ' ') || '---';
  const subject = data?.subject || '---';
  const message = data?.text
    ? data.text.replaceAll('<a ', '<a target="_blank" ')
    : null;

  return (
  <Scaffold>
    <S.MainPanel>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          Histórico de Alertas
          {loading && <S.LoadingPage />}
        </h1>

        <S.HeaderButtons>
          <S.ButtonMini btStyle="dark" onClick={() => navigate(-1)}>
            <S.IconArrowLeft />
            Voltar
          </S.ButtonMini>
        </S.HeaderButtons>
      </S.PageHeader>

      <S.PageContent>
        <S.ContentModal>
          <S.BorderContent>

            <S.InfoContent>
              <S.TitleLabel>ID</S.TitleLabel>
              <S.InfoText>{data?.id || '---'}</S.InfoText>
            </S.InfoContent>

            <S.InfoContent>
              <S.TitleLabel>Destinatários</S.TitleLabel>
              <S.InfoText>{receivers}</S.InfoText>
            </S.InfoContent>

            <S.InfoContent>
              <S.TitleLabel>Assunto</S.TitleLabel>
              <S.InfoText>{subject}</S.InfoText>
            </S.InfoContent>

            <S.InfoContent>
              <S.TitleLabel>Mensagem</S.TitleLabel>
              {message ? (
                <iframe
                  title="email-preview"
                  srcDoc={message}
                  style={{
                    width: '100%',
                    border: 'none',
                    minHeight: '1000px',
                    background: '#fff',
                  }}
                />
              ) : (
                <S.InfoText>---</S.InfoText>
              )}
            </S.InfoContent>

          </S.BorderContent>
        </S.ContentModal>
      </S.PageContent>
    </S.MainPanel>
  </Scaffold>
  );
};